define('models/PatientStatus',[],function() {
	return {
		// 0: {}, // None
		1: { // RoutineDischarge
			code: '01',
			desc: 'Discharged to home or self care (routine discharge)'
		},
		2: { // ShortTermHospitalDischarge
			code: '02',
			desc: 'Discharged/transferred to another short-term general hospital'
		},
		3: { // DischargeSNFMedicareCert
			code: '03',
			desc: 'Discharged/transferred to skilled nursing facility (SNF)'
		},
		4: { // DischargeICF
			code: '04',
			desc: 'Discharged/transferred to an intermediate care facility (ICF)'
		},
		5: { // DischargeOther
			code: '05', 
			desc: 'Discharged/transferred to another type of institution'
		},
		6: { // DischargeHomeHHA
			code: '06',
			desc: 'Discharged/transferred to home under care of organized home health service organization'
		},
		7: { // DiscontinuedCare
			code: '07',
			desc: 'Left against medical advice'
		},
		8: { // AdmittedInpatientHospital
			code: '09',
			desc: 'Admitted as an inpatient to this hospital (Medicare Outpatient Only)'
		},
		9: { // Expired
			code: '20',
			desc: 'Expired (or did not recover - Christian Science patient)'
		},
		10: { // StillPatient
			code: '30',
			desc: 'Still a patient'
		},
		11: { // ExpiredHome
			code: '40',
			desc: 'Expired at home'
		},
		12: { // ExpiredMedicalFacility
			code: '41',
			desc: 'Expired in a medical facility; e.g., hospital, SNF, ICF, or free-standing hospice (Medicare Hospice Care Only)'
		},
		13: { // ExpiredUnknown
			code: '42',
			desc: 'Expired - place unknown (Medicare Hospice Care Only)'
		}
	}
});
